import { DotLottieWorkerReact } from '@lottiefiles/dotlottie-react'

import { useStarAnim } from '@shared'

import styles from './Discount.module.scss'
import { Rectangle } from './assets'

export const Discount = ({
  discount,
}: {
  discount: string
}) => {
  const { starAnim } = useStarAnim()

  return (
    <div className={styles.discount}>
      <Rectangle discount={discount} />
      
      {starAnim && (
          <div className={styles.star}>
            <DotLottieWorkerReact
              data={starAnim}
              autoplay
              loop
              width={100}
              height={100}
            />
          </div>

      )}
    </div>
  )
}
